import { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@/components/Button'

export default class ErrorBoundary extends Component {
  state = { hasError: false, error: null }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen font-avenir text-center bg-grey-98">
          <h2 className="type-header-3 text-grey-10">Something went wrong</h2>
          <p className="type-body-2 mt-2 text-grey-50">
            {this.state.error?.message || 'An unexpected error occurred.'}
          </p>
          <div className="mt-8">
            <Button round onClick={() => window.location.replace('/submittals')}>
              Go to Home
            </Button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}
